export enum BurialLayoutType {
    infos = 'infos',
    burials = 'burials'
}
